<mat-toolbar class="bg-danger">
    <span>Pytanie <i class="fa-solid fa-question"></i></span>
    <span class="toolbar-spacer"></span>
    <button class="text-white" mat-icon-button matTooltip="Zamknij" matTooltipPosition="below"
            [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>
<mat-dialog-content>
    <div class="container text-center">
        <h4> {{ statusArchive ? 'Czy archiwizować zlecenie o numerze:' : 'Czy rozliczyć zlecenie o numerze:' }} {{ serviceOrderID }}
            ?</h4>
        <app-service-order-invoice-form [editMode]="statusArchive" #data></app-service-order-invoice-form>
        <div class="py-2">
            <mat-checkbox color="primary"
                          [(ngModel)]="checked">{{ statusArchive ? 'Tak, zarchiwizuj.' : 'Tak, rozliczyć.' }}
            </mat-checkbox>
        </div>
    </div>
</mat-dialog-content>
<div class="d-flex justify-content-end pb-4">
    <button class="full-width mx-2" mat-raised-button [mat-dialog-close]="true"
            matTooltip="Cancel - close modal" matTooltipPosition="below">
        <i class="fa-solid fa-xmark"></i> NIE
    </button>
    <button class="full-width mx-2" mat-raised-button color="warn" (click)="completed()"
            matTooltip="Completed" matTooltipPosition="below"
            [disabled]="!checked">TAK <i class="fa-solid fa-check"></i></button>
</div>
